import {FileValidationRule} from "./file-validation-rule";

export class FilenameLengthValidationRule implements FileValidationRule {
    private readonly MAX_FILENAME_LENGTH = 80;

    public readonly errorKey = 'maxFilename';
    public validate(file:File): boolean {
        return file.name.length <= this.MAX_FILENAME_LENGTH;
    }
}